import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import { DropdownMenuSubTrigger, useForwardProps } from 'reka-ui';
import { cn } from '../utils';
export default /*@__PURE__*/ _defineComponent({
    ...{ inheritAttrs: false },
    __name: 'MenuSubTrigger',
    props: {
        disabled: { type: Boolean, required: false },
        textValue: { type: String, required: false },
        asChild: { type: Boolean, required: false },
        as: { type: null, required: false },
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const delegated = computed(() => {
            const { class: _ignored, ...rest } = props;
            return rest;
        });
        const forwarded = useForwardProps(delegated);
        // With `as-child` the caller's own element becomes the trigger and brings its own look,
        // so the default row styling would fight it.
        const triggerClass = computed(() => props.asChild
            ? cn(props.class)
            : cn('relative flex cursor-pointer select-none items-center rounded p-1.5 text-sm outline-none whitespace-nowrap', 'hover:bg-accent hover:text-accent-foreground', 'data-highlighted:bg-accent data-highlighted:text-accent-foreground', 'data-[state=open]:bg-accent data-[state=open]:text-accent-foreground', 'data-disabled:pointer-events-none data-disabled:opacity-50', props.class));
        const __returned__ = { props, delegated, forwarded, triggerClass, get DropdownMenuSubTrigger() { return DropdownMenuSubTrigger; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
